import * as React from 'react';
import { Container, Row, Col, Label } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import './preferences.scss';
import { RootState } from '@src/app/_redux/root-reducer';
import { connect } from 'react-redux';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import { Accordion } from '@src/app/_global/components/accordion/Accordion';
import { Field, reduxForm, change } from 'redux-form';
import {
  Checkbox,
  SimplerSelectV2,
  TextInput,
} from '@src/app/_global/components/form-elements';
import { Dispatch, bindActionCreators } from 'redux';
import { actionCreators } from '@src/app/accounts/preferences/actions';
import { getClientNamesForCustomers } from '@src/app/accounts/selectors';
import { CustomCustomer, CustomOrder } from '@CDSGlobal/gc-backend';
import { LoadingView } from '@src/app/_global/components/Loading';
import { ResponseView } from '@src/app/accounts/preferences/components/ResponseView';
import { required, email, selectRequired } from '@src/app/_global/field-validations';
export interface PreferencesProps {
  clientConfig: any;
  adminConfig: any;
  clientNames: any;
  customers: Array<CustomCustomer>;
  preferenceData: any;
  emailAuthOnly: any;
  redeemGiftOnly: boolean;
  directViewLogin: boolean;
  directViewAccountNumber: any;
  orders: Array<CustomOrder>;
}

export class Form extends React.Component<any> {
  history: any = this.props.history;

  state = {
    preferencesFound: true,
    selectedProdIdAlias: '',
    emailCommunicationPreferences: [
      { code: '', client_title: '', default_title: '' },
    ],
    mailCommunicationPreferences: [
      { code: '', client_title: '', default_title: '' },
    ],
    currentCustomerPermissions: {},
    selectedProductName: '',
    redeemedGiftEntityId: '',
    redeemedGiftEntityType: '',
    redeemedGiftRemoveSuspendDate: '',
  };

  constructor(props: any, context: any) {
    super(props, context);
    this.onProductChange = this.onProductChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
  }

  componentWillMount() {
    this.props.savePreferencesCancel();
  }

  componentDidMount() {
    // Single Subscription view?  If so, go right to Preferences without making the customer select a product.

    if (this.props.customers[0].systemCode === 'CORE') {
      if ((this.props.dedupedOrders && this.props.dedupedOrders.length === 1) 
      || (this.props.directViewLogin && this.props.directViewAccountNumber)) {
        let selectedProdId = this.props.dedupedOrders[0].prodIdAlias;        
        this.initializeState(selectedProdId);
      } else {
        if (!this.props.dedupedOrders || this.props.dedupedOrders.length === 0) {
          this.setState({
            preferencesFound: false,
          });
        }
      }
      if (this.props.redeemGiftOnly) {
        let giftOrder = this.props.dedupedOrders.find((ord: any) => {
          return ord.entityId === this.props.entityIdParm;
        });
        this.setState({
          redeemedGiftEntityId: giftOrder.entityId,
          redeemedGiftEntityType: giftOrder.entityType,
          redeemedGiftRemoveSuspendDate: giftOrder.coreRemoveSuspendDate
        });
        this.props.dispatch(change('account-preferences', 'captureEmail' , this.props.emailAddressParm));
      }
    } else {
      if ((this.props.clientNames && this.props.clientNames.length === 1) 
      || (this.props.directViewLogin && this.props.directViewAccountNumber)) {
        let selectedProdId = '';
        if (this.props.directViewAccountNumber) {
          let orderCustomer =  this.props.customers.find(customer => { 
            return customer.accountNumber === this.props.directViewAccountNumber; 
          });
          selectedProdId = orderCustomer.prodIdAlias;
        } else {
          selectedProdId = this.props.clientNames[0].prodIdAlias;
        }
        this.initializeState(selectedProdId);
      } else {
        if (!this.props.clientNames || this.props.clientNames.length === 0) {
          this.setState({
            preferencesFound: false,
          });
        }
      }

    }
    
  }

  handleCancel() {
    this.props.savePreferencesCancel();
    this.props.history.push('/accounts/summary');
  }

  onSaveClick(values: any, state: any) {
    let selectedCustomer = this.props.customers[0].systemCode === 'CORE' ? this.props.customers[0] : this.props.customers.find((cust: any) => {
      return cust.prodIdAlias === state.selectedProdIdAlias;
    });
    let payloads: Array<any> = [];
    if (selectedCustomer.systemCode === 'CORE') {
      let payload = {};
      if ((values.hasOwnProperty('promoteByMail') || values.hasOwnProperty('promoteByPhone')) && !this.props.emailAuthOnly && !this.props.redeemGiftOnly) {
        payload = {
          'systemCode': selectedCustomer.systemCode,
          'googleAnalyticsCategory':  'Change permissions',
          'googleAnalyticsLabel': state.selectedProdIdAlias,
          'coreTransactionType': 'mailPermissions',
          'accountNumber': selectedCustomer.accountNumber,
          'prodIdAlias': selectedCustomer.prodIdAlias,
          'addressId': selectedCustomer.address.addressId,
          'newPermissions': values, 
        };
        for (let key in values) {
          if (key === 'promoteByMail' || key === 'promoteByPhone') {
            if (key) {
              payload[key] = values[key] ? 'Y' : 'N';
            }
          }
        }
        payloads.push(payload);
      }
      if ((values.hasOwnProperty('promoteByEmail') || values.hasOwnProperty('firstPartyConsent') || 
      values.hasOwnProperty('thirdPartyConsent')) && !this.props.emailAuthOnly && !this.props.redeemGiftOnly 
        && selectedCustomer.email) {
        payload = {
          'systemCode': selectedCustomer.systemCode,
          'googleAnalyticsCategory':  'Change permissions',
          'googleAnalyticsLabel': state.selectedProdIdAlias,
          'coreTransactionType': 'emailPermissions',
          'accountNumber': selectedCustomer.accountNumber,
          'prodIdAlias': selectedCustomer.prodIdAlias,
          'email': selectedCustomer.email,          
          'newPermissions': values, 
        };
        for (let key in values) {
        if (key === 'promoteByEmail' || key === 'firstPartyConsent' || key === 'thirdPartyConsent') {
            if (key) {
              payload[key] = values[key] ? 'Y' : 'N';
            }
          }
        }
        payloads.push(payload);
      }
      if (values.hasOwnProperty('canPromoteForRenewal') && !this.props.emailAuthOnly && !this.props.redeemGiftOnly) {
        // find all subscription orders and send a promoteRenewal transaction for each
        this.props.dedupedOrders.forEach(ord => {
          if (ord.prodIdAlias === state.selectedProdIdAlias) {
            payload = {
              'systemCode': selectedCustomer.systemCode,
              'googleAnalyticsCategory':  'Change permissions',
              'googleAnalyticsLabel': state.selectedProdIdAlias,
              'coreTransactionType': 'renewalPermissions',
              'accountNumber': selectedCustomer.accountNumber,
              'prodIdAlias': selectedCustomer.prodIdAlias,
              'entityId': ord.entityId, 
              'entityType': ord.entityType, 
              'newPermissions': values, 
            };
            for (let key in values) {
              if (key === 'canPromoteForRenewal') {
                if (key) {
                  payload[key] = values[key] ? 'Y' : 'N';
                }
              }
            }
            payloads.push(payload);
          }
        });
      }
      if (values.hasOwnProperty('promoteByEmail') && this.props.emailAuthOnly && !this.props.redeemGiftOnly) {
        // if emailAuthOnly then only send that field.
        payload = {
          'systemCode': selectedCustomer.systemCode,
          'googleAnalyticsCategory':  'Change permissions',
          'googleAnalyticsLabel': state.selectedProdIdAlias,
          'coreTransactionType': 'emailPermissions',
          'accountNumber': selectedCustomer.accountNumber,
          'prodIdAlias': selectedCustomer.prodIdAlias,
          'email': selectedCustomer.email,          
          'newPermissions': values, 
        };
        for (let key in values) {
          if (key === 'promoteByEmail' ) {
            if (key) {
              payload[key] = values[key] ? 'Y' : 'N';
            }
          }
        }
        payloads.push(payload);
      }
      if (values.hasOwnProperty('promoteByEmail') && !this.props.emailAuthOnly && this.props.redeemGiftOnly) {
        // redeem gift by doing a COFE, update email permission and resume subscription (all handled in the backend)
        payload = {
          'systemCode': selectedCustomer.systemCode,
          'googleAnalyticsCategory':  'Redeem Gift',
          'googleAnalyticsLabel': state.selectedProdIdAlias,
          'coreTransactionType': 'redeemgift',
          'accountNumber': selectedCustomer.accountNumber,
          'prodIdAlias': selectedCustomer.prodIdAlias,
          'email': values.captureEmail,         
          'addressId': selectedCustomer.address.addressId, 
          'newPermissions': values, 
          'order': {
            'entityId': this.state.redeemedGiftEntityId,
            'entityType': this.state.redeemedGiftEntityType,
          },
          'removeSuspendDate': this.state.redeemedGiftRemoveSuspendDate
        };
        for (let key in values) {
          if (key === 'promoteByEmail' ) {
            if (key) {
              payload[key] = values[key] ? 'Y' : 'N';
            }
          }
        }
        payloads.push(payload);
      }
    } else {
      if (values.hasOwnProperty('emailAuthorization') && this.props.emailAuthOnly && !this.props.redeemGiftOnly) {
        // if emailAuthOnly then only send that field.
        let payload = {
          'systemCode': selectedCustomer.systemCode,
          'newPermissions': values, 
          'currentPermissions': state.currentCustomerPermissions, 
          'googleAnalyticsCategory': 'Change Email Authorization',
          'googleAnalyticsLabel': state.selectedProdIdAlias,
          'selectedProdIdAlias': state.selectedProdIdAlias
        };
        for (let key in values) {
          if (key === 'emailAuthorization' ) {
            if (key) {
              payload[key] = values[key] ? 'Y' : 'N';
            }
          }
        }
        payloads.push(payload);
      } else {
        payloads.push(
          {
            'systemCode': selectedCustomer.systemCode,
            'newPermissions': values, 
            'currentPermissions': state.currentCustomerPermissions, 
            'googleAnalyticsCategory': 'Change permissions',
            'googleAnalyticsLabel': state.selectedProdIdAlias,
            'selectedProdIdAlias': state.selectedProdIdAlias
          }
        );
      }

    }
    this.props.savePreferences(payloads);
  }

  onProductChange(selectedProduct: any) {
    this.initializeState(selectedProduct.prodIdAlias);
  }

  initializeState(selectedProdIdAlias: string) {
    let selectedCustomer = this.props.customers[0].systemCode === 'CORE' ? this.props.customers[0] : this.props.customers.find((cust: any) => {
      return cust.prodIdAlias === selectedProdIdAlias;
    });
    if (selectedCustomer) {
      this.props.destroy();
      let newCommPreferences = getAdminConfigTableItem(
        this.props.adminConfig,
        this.props.clientConfig,
        'CommunicationPreferences',
        selectedProdIdAlias,
      );
      let allPermissions =
        Object.keys(newCommPreferences).length !== 0
          ? [...newCommPreferences.Email, ...newCommPreferences.Mail]
          : [];
      allPermissions.forEach(newPref => {
        if (newPref) {
          if (selectedCustomer.permissions[newPref.code]) {
            this.props.change(
              newPref.code,
              selectedCustomer.permissions[newPref.code] === 'Y',
            );
          } else {
            if (selectedCustomer.systemCode === 'CORE') {
              if (newPref.code === 'canPromoteForRenewal') {
                this.props.dedupedOrders.forEach(ord => {
                  if (ord.prodIdAlias === selectedProdIdAlias) {
                    this.props.change(
                      newPref.code,
                      ord.canPromoteForRenewal === 'Y',
                    );
                  }
                });
              } else {
                this.props.change(newPref.code, false);
              }

            } else {
              this.props.change(newPref.code, false);
            }           
          }
        }
      });

      this.props.change('email', selectedCustomer.email);
      this.props.change('accountNumber', selectedCustomer.accountNumber);
      this.props.change('prodIdAlias', selectedCustomer.prodIdAlias);

      this.setState({
        preferencesFound: allPermissions.length > 0 ? true : false,
        selectedProdIdAlias: selectedProdIdAlias,
        mailCommunicationPreferences: newCommPreferences.Mail,
        emailCommunicationPreferences: newCommPreferences.Email,
        currentCustomerPermissions: selectedCustomer.permissions,
        selectedProductName: selectedCustomer.productName
      });
    }
  }

  render() {
    const { handleSubmit, clientNames, preferenceData, emailAuthOnly, directViewLogin, dedupedOrdersProdIdAlias, customers, redeemGiftOnly, emailAddressParm} = this.props;
    let selectedCustomer = this.props.customers[0].systemCode === 'CORE' ? this.props.customers[0] : this.props.customers.find((cust: any) => {
      return cust.prodIdAlias === this.state.selectedProdIdAlias;
    });
    let emailAuthPreference = this.state.emailCommunicationPreferences && this.state.emailCommunicationPreferences.find(pref => {
      return (pref.code === 'emailAuthorization' || pref.code === 'promoteByEmail'); 
    });
    return (
      <Container className="preferences-ct" tabIndex={0} fluid={true}>
        { preferenceData.loading ? (
          <LoadingView loadingText="Loading..."/>
        ) : (
          preferenceData.preferenceSavedResult !== null ? (
            <ResponseView
              onExit={this.handleCancel}
              adminConfig={this.props.adminConfig}
              clientConfig={this.props.clientConfig}
              response={preferenceData.preferenceSavedResult}
              customer={selectedCustomer}
              directViewLogin={directViewLogin}
              emailAuthOnly={emailAuthOnly}
              redeemGiftOnly={redeemGiftOnly}
            />
          ) : (
            <div>
              <Row>
                <Col xs={12} sm={12} md={12}>
                  {this.state.preferencesFound ? (
                    <div className="view-heading" id="view-heading">
                      <FormattedMessage
                        id="acnt.preferences"
                        description="select preferences"
                        defaultMessage={emailAuthOnly ? 'Change Your Email Preference' : (redeemGiftOnly ? ' ' : 'Select Preferences')}
                      />
                    </div>
                  ) : (
                    <div className="view-heading" id="view-heading">
                      <FormattedMessage
                        id="acnt.no.preferences"
                        description="select no preferences"
                        defaultMessage={'There are no preferences to display.'} 
                      />
                    </div>
                  )}
                </Col>
              </Row>

              {!this.state.selectedProdIdAlias && this.state.preferencesFound && (
                <Row>
                  <div className="preferences">
                    <Label for="productSelect">Please choose a product to update</Label>
                    <Field
                      name="productSelected"
                      label="Select a product"
                      id="productSelect"
                      component={SimplerSelectV2}
                      valueKey={'prodIdAlias'}
                      labelKey={customers[0].systemCode === 'CORE' ? 'productName' : 'clientName'}
                      options={customers[0].systemCode === 'CORE' ? dedupedOrdersProdIdAlias : clientNames}
                      onChange={this.onProductChange}
                      validate={[selectRequired]}
                      ariaLabel="Select a product"
                      placeholder="Select a product"
                      searchable="true"
                    />
                  </div>
                </Row>
              )}

              <form onSubmit={handleSubmit(fields => this.onSaveClick(fields,  this.state))}>
                {this.state.selectedProdIdAlias 
                  && this.state.mailCommunicationPreferences 
                  && this.state.mailCommunicationPreferences.length > 0 
                  && !emailAuthOnly 
                  && !redeemGiftOnly
                  && (
                  <Row>
                    <div className="preferences" tabIndex={1}>
                      <Accordion
                        defaultOpen={this.state.selectedProdIdAlias !== ''}
                        title={'Mailing/Phone Preferences'}
                        orderNum="one"
                      >
                        <div className="preferences-body">
                          {this.state.mailCommunicationPreferences &&
                            this.state.mailCommunicationPreferences.map(
                              preference => (
                                <div key={preference.code} className="d-flex mb-3 ">
                                  <div className="ml-2">
                                    {preference.code && (
                                      <Field
                                        name={preference.code}
                                        id={'mailPrefs'}
                                        label={
                                          preference.client_title
                                            ? preference.client_title
                                            : preference.default_title
                                        }
                                        component={Checkbox}
                                        type="checkbox"
                                      />
                                    )}
                                  </div>
                                </div>
                              ),
                            )}
                        </div>
                      </Accordion>
                    </div>
                  </Row>
                )}
                {this.state.selectedProdIdAlias 
                  && this.state.emailCommunicationPreferences 
                  && this.state.emailCommunicationPreferences.length > 0 
                  && !emailAuthOnly
                  && !redeemGiftOnly
                  && selectedCustomer.email
                  && (
                  <Row>
                    <div className="preferences" tabIndex={1}>
                      <Accordion
                        defaultOpen={this.state.selectedProdIdAlias !== ''}
                        title={'Email Preferences'}
                        orderNum="two"
                      >
                        <div className="preferences-body">
                          {this.state.emailCommunicationPreferences &&
                            this.state.emailCommunicationPreferences.map(
                              preference => (
                                <div key={preference.code} className="d-flex mb-3 ">
                                  <div className="ml-2">
                                    {preference.code && (
                                      <Field
                                        name={preference.code}
                                        id={'emailPrefs'}
                                        label={
                                          preference.client_title
                                            ? preference.client_title
                                            : preference.default_title
                                        }
                                        component={Checkbox}
                                        type="checkbox"
                                      />
                                    )}
                                  </div>
                                </div>
                              ),
                            )}
                        </div>
                      </Accordion>
                    </div>
                  </Row>
                )}
                {this.state.selectedProdIdAlias 
                  && this.state.emailCommunicationPreferences 
                  && this.state.emailCommunicationPreferences.length > 0 
                  && emailAuthOnly
                  && !redeemGiftOnly
                  && (
                  <Row>
                    <div className="preferences" tabIndex={1}>
                      <div className="emailauth-preferences-body">
                        {this.state.emailCommunicationPreferences &&
                          this.state.emailCommunicationPreferences.map(
                            preference => (
                              <div key={preference.code} className="d-flex mb-3 ">
                                <div className="ml-2">
                                  {preference.code && (preference.code === 'emailAuthorization' || preference.code === 'promoteByEmail' ) && (
                                    <Field
                                      name={preference.code}
                                      id={'emailPrefs'}
                                      label={
                                        preference.client_title
                                          ? preference.client_title
                                          : preference.default_title
                                      }
                                      component={Checkbox}
                                      type="checkbox"
                                    />
                                  )}
                                </div>
                              </div>
                            ),
                          )}
                      </div>
                    </div>
                  </Row>
                )}
                {this.state.selectedProdIdAlias 
                  && this.state.emailCommunicationPreferences 
                  && this.state.emailCommunicationPreferences.length > 0 
                  && !emailAuthOnly
                  && redeemGiftOnly
                  && (
                  <Row>
                    <div className="preferences" tabIndex={1}>
                      <Field
                        name="captureEmail"
                        id={'captureEmail'}
                        className="capture-email"
                        type="text"
                        label={'Email '}
                        validate={[email, required]}
                        component={TextInput}
                      />
                      <div className="redeem-preferences-body">
                        {this.state.emailCommunicationPreferences &&
                          this.state.emailCommunicationPreferences.map(
                            preference => (
                              <div key={preference.code} className="d-flex mb-3 ">
                                <div className="ml-2">
                                  {preference.code && preference.code === 'promoteByEmail' && (
                                    <Field
                                      name={preference.code}
                                      id={'emailPrefs'}
                                      label={
                                        preference.client_title
                                          ? preference.client_title
                                          : preference.default_title
                                      }
                                      component={Checkbox}
                                      type="checkbox"
                                    />
                                  )}
                                </div>
                              </div>
                            ),
                          )}
                      </div>
                    </div>
                  </Row>
                )}
                <Row>
                  <Col xs={12} sm={12} md={12} className="button-ct">
                    {this.state.selectedProdIdAlias && this.state.preferencesFound && !directViewLogin && (
                      <div>
                        <button className="btn btn-primary" type="submit">
                          <FormattedMessage
                            id="email.changeemail"
                            description="heading change email and address permisions button"
                            defaultMessage="Save"
                          />
                        </button>
                        <button
                          className="btn btn-light ml-2"
                          type="button"
                          onClick={this.handleCancel}
                        >
                          <FormattedMessage
                            id="app.cancel"
                            description="heading cancel button"
                            defaultMessage="Cancel"
                          />
                        </button>
                      </div>
                    )}
                    {(!this.state.selectedProdIdAlias || !this.state.preferencesFound) && !directViewLogin && !redeemGiftOnly && (
                      <div>
                        <button
                          className="btn btn-primary mt-4"
                          type="button"
                          onClick={this.handleCancel}
                        >
                          <FormattedMessage
                            id="app.cancel"
                            description="heading cancel button"
                            defaultMessage="Cancel"
                          />
                        </button>
                      </div>
                    )}
                    {this.state.selectedProdIdAlias && this.state.preferencesFound && directViewLogin && emailAuthPreference && (
                      <div>
                        <button className="btn btn-primary" type="submit">
                          <FormattedMessage
                            id="email.changeemail"
                            description="heading change email and address permisions button"
                            defaultMessage="Save"
                          />
                        </button>
                      </div>
                    )}
                  </Col>
                </Row>
                <input name="accountNumber" type="hidden" />
                <input name="email" type="hidden" />
                <input name="prodIdAlias" type="hidden" />
              </form>
            </div>
          )
        )}
      </Container>
    );
  }
}
const PreferenceForm = reduxForm({
  form: 'account-preferences',
  forceUnregisterOnUnmount: true,
  destroyOnUnmount: true,
})(Form);

const mapStateToProps = (state: RootState, props) => {
  let dedupedOrders = state.account.orderData.orders ? state.account.orderData.orders.filter((order, index, self) => {
    return  self.findIndex(t =>  (t.prodIdAlias === order.prodIdAlias) && (t.entityId === order.entityId) 
              && (!order.isSynchronizedPublication) && (order.entityType !== 'product' || (order.entityType === 'product' 
              && order.orderItems && order.orderItems[0] && order.orderItems[0].orderItemType !== 'Package'))) === index; // dedupe
  }) : [];
  // override the product name if the entity type of the product order is publication or memebership
   // this is necessary to make sure the drop down doesn't have duplicate options for different prod ids
  let updatedDedupedOrders = dedupedOrders.map(order => {
    let newOrder = {...order};
    if (order.entityType === 'product' && order.orderItems && order.orderItems[0] 
        && (order.orderItems[0].entityType === 'publication' || order.orderItems[0].entityType === 'membership')) {
      let clientProperties = getAdminConfigTableItem(state.adminConfig, state.clientConfig, 'ClientProperties', order.prodIdAlias);
      newOrder.productName = clientProperties.ProductName;
    }
    return newOrder;
  });

  const dedupedOrdersProdIdAliasOrders = updatedDedupedOrders.filter((order, index, self) =>
    self.findIndex(t => t.prodIdAlias === order.prodIdAlias) === index
  );

  return {
    clientConfig: state.clientConfig,
    adminConfig: state.adminConfig,
    clientNames: getClientNamesForCustomers(state),
    customers: state.account.customerData.customers,
    orders: state.account.orderData.orders,
    dedupedOrders: updatedDedupedOrders,
    dedupedOrdersProdIdAlias: dedupedOrdersProdIdAliasOrders,
    preferenceData: state.account.preferenceData,
    emailAuthOnly: props.location.pathname.split('/')[2] === 'email-auth' ? true : false,
    redeemGiftOnly: props.location.pathname.split('/')[2] === 'redeemgift' ? true : false,
    directViewLogin: state.userState.directViewLogin,
    directViewAccountNumber: state.userState.loginAccountNumber,
    entityIdParm: props.match.params.orderNumber,  // used as entityId for Redeem Gift
    emailAddressParm: props.match.params.emailAddress,
  };
};
const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      savePreferences: actionCreators.savePreferencesStart,
      savePreferencesCancel: actionCreators.savePreferencesCancel,
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreferenceForm);
